module.exports = __webpack_public_path__ + "img/Jump Casting56.f0764958.jpg";